import { useOrganizationStore } from '../store/organizationStore';
import useQueryString from './queryParams/useQueryString';

function useOrganization() {
  const { organizationInfo } = useOrganizationStore();
  const organizationId = useQueryString().queryParams.get('organizationId');

  const organization_id = organizationId ?? organizationInfo?.id ?? '';

  const { id, ...restOrganizationInfo } = organizationInfo || {};

  return {
    id: organization_id,
    ...restOrganizationInfo,
  };
}

export default useOrganization;
